import { css } from 'lit';
export default css `
  :host {
    display: block;
    width: max-content;
  }
`;
//# sourceMappingURL=styles.js.map